import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import DepartmentText from './DepartmentText';
import { track } from '../../helpers';
import TrackingEvents from '../../common/models/TrackingEvents';
import Departments from '../../common/models/Departments';

class DepartmentBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hoverIndex: null,
      women: Departments.getWomenInternalName(),
      men: Departments.getMenInternalName(),
      kids: Departments.getKidsInternalName(),
    };

    this.isActive = this.isActive.bind(this);
    this.selectDepartment = this.selectDepartment.bind(this);
    this.changeHoverIndex = this.changeHoverIndex.bind(this);
  }

  isActive(index) {
    const { hoverIndex } = this.state;
    const { department } = this.props;
    return !hoverIndex ? index === Departments.getInternalName(department) : index === hoverIndex;
  }

  componentDidUpdate(prevProps) {
    const { resetDepartment, handleHover, handleClick, initialDepartment } = this.props;
    if (resetDepartment && resetDepartment !== prevProps.resetDepartment) {
      this.setState({
        hoverIndex: initialDepartment,
      });

      if (handleHover) {
        handleHover(initialDepartment);
      } else {
        handleClick(initialDepartment);
      }
    }
  }

  selectDepartment(department, e) {
    const { context, handleClick } = this.props;
    track(TrackingEvents.departmentSelected(), {
      categoryDepartment: { department: department.toLowerCase() },
      ui: { context },
    });
    handleClick(department, e);
  }

  changeHoverIndex(hoverIndex) {
    const { handleHover, context } = this.props;
    if (context && context === 'search') {
      return;
    }
    this.setState({
      hoverIndex,
    });

    if (handleHover) {
      handleHover(hoverIndex);
    }
  }

  render() {
    const { underline, fontSize, context, handleHover } = this.props;
    return (
      <>
        <div>
          <DepartmentText
            onClick={e => this.selectDepartment(Departments.getWomenInternalName(), e)}
            fontSize={fontSize}
            data-cy={`input-link-${context}-women`}
            active={this.isActive(Departments.getWomenInternalName())}
            underline={underline}
            title={Departments.getWomenName()}
            onMouseEnter={() => {
              if (handleHover) {
                this.changeHoverIndex(Departments.getWomenInternalName());
              }
            }}
            onFocus={() => {}}
          >
            {Departments.getWomenName()}
          </DepartmentText>
        </div>
        <div style={{ margin: '0 36px' }}>
          <DepartmentText
            onMouseEnter={() => {
              if (handleHover) {
                this.changeHoverIndex(Departments.getMenInternalName());
              }
            }}
            onFocus={() => {}}
            onClick={e => this.selectDepartment(Departments.getMenInternalName(), e)}
            fontSize={fontSize}
            data-cy={`input-link-${context}-men`}
            active={this.isActive(Departments.getMenInternalName())}
            underline={underline}
            title={Departments.getMenName()}
          >
            {Departments.getMenName()}
          </DepartmentText>
        </div>
        <div>
          <DepartmentText
            onMouseEnter={() => {
              if (handleHover) {
                this.changeHoverIndex(Departments.getKidsInternalName());
              }
            }}
            onFocus={() => {}}
            data-cy={`input-link-${context}-kids`}
            onClick={e => this.selectDepartment(Departments.getKidsInternalName(), e)}
            fontSize={fontSize}
            active={this.isActive(Departments.getKidsInternalName())}
            underline={underline}
            title={Departments.getKidsName()}
          >
            {Departments.getKidsName()}
          </DepartmentText>
        </div>
      </>
    );
  }
}

DepartmentBox.propTypes = {
  department: PropTypes.string,
  handleClick: PropTypes.func,
  context: PropTypes.string,
  underline: PropTypes.bool,
  fontSize: PropTypes.string,
};

export default DepartmentBox;
